import { render, staticRenderFns } from "./CreateInstantModal.vue?vue&type=template&id=18fe451f&"
import script from "./CreateInstantModal.vue?vue&type=script&lang=ts&"
export * from "./CreateInstantModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2898369969/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fe451f')) {
      api.createRecord('18fe451f', component.options)
    } else {
      api.reload('18fe451f', component.options)
    }
    module.hot.accept("./CreateInstantModal.vue?vue&type=template&id=18fe451f&", function () {
      api.rerender('18fe451f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/CreateInstantModal.vue"
export default component.exports